import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import LoginComponent from '../views/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: "/login",
    name: "Login",
    component: LoginComponent
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
})

export default router

function patchRouterMethod (router, methodName)
{
  router['old' + methodName] = router[methodName]
  router[methodName] = async function (location)
  {
    return router['old' + methodName](location).catch((error) =>
    {
      if (error.name === 'NavigationDuplicated')
      {
        return this.currentRoute
      }
      throw error
    })
  }
}

patchRouterMethod(router, 'push')
patchRouterMethod(router, 'replace')



// WEBPACK FOOTER //
// ./src/router/index.js